
import angular from 'angular';
import '../components/tree';

const module = angular.module('whyline.controllers.sectors', [
  'whyline.components.tree',
]);

const SectorsController = ($scope, $state, $translate, dialog) => {
  /*@ngInject*/
  $scope.placeId = $state.params.placeId ? $state.params.placeId : false;
  $scope.createRootSector = () => {
    $scope.$broadcast('new-root-sector');
  }

  $scope.savePlaceSectors = () => {
    dialog
				.confirm($translate.instant('sectors_update_alert'))
				.then(() => $scope.$broadcast('save-place-sector'))
				.catch(() => 'canceled');
  }
};

module.exports = module.controller('SectorsController', SectorsController);